import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ARCHIVE_MODE_ENABLED,
  isArchivePathAllowed,
} from "./archiveConfig";

export default function ArchiveRouteGuard() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!ARCHIVE_MODE_ENABLED) {
      return;
    }

    if (isArchivePathAllowed(location.pathname)) {
      return;
    }

    navigate("/customer-list", { replace: true });
  }, [location.pathname, navigate]);

  return null;
}
